
<template>
  <div>
    <div style="width: 100%" class="">
      <div class="post card p-4">
        <div class="post card p-4">
          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div style="height: 90px; width: 150px" class="line"></div>
              </div>
            </div>
            <div style="display: grid" class="col-md-4">
              <div
                style="height: 60px; width: 100%; margin-top: 20px"
                class="line"
              ></div>
            </div>
          </div>
        </div>
        <div class="post card p-4">
          <div class="row">
            <div class="col-md-10">
              <div class="row">
                <div style="height: 60px; width: 150px" class="line"></div>
              </div>
            </div>
            <div style="display: grid" class="col-md-2">
              <div style="height: 20px; width: 120px" class="line"></div>
              <div style="height: 20px; width: 120px" class="line"></div>
            </div>
          </div>
        </div>

        <div class="post card p-4">
          <div class="row">
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md"></div>
          </div>
          <div class="row">
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md"></div>
          </div>
          <div class="row">
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md"></div>
          </div>
        </div>
        <div class="post card p-4">
          <div class="row">
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md"></div>
          </div>
          <div class="row">
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md-4"></div>
            <div style="height: 20px" class="line col-md"></div>
          </div>
        </div>
        <div class="post card p-4">
          <div class="row">
            <div style="height: 20px" class="line col-md-12"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- End row  -->
  </div>
</template>
<script>
export default {
  name: "SKL-Hotel-Details",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.post {
      background-color: #fff;
    -webkit-box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
    -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
    border-radius: 15px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15;
  padding: 5px 15px 5px 15px;
  margin-bottom: 15px;
  margin-left: 0px;
  margin-right: 0px;
}
.post .avatar {
  display: inline-table;
  /* float: right; */
  width: 50px;
  height: 50px;
  background-color: #ccc;
  border-radius: 25%;
  /* margin: 8px; */
  background-image: linear-gradient(
    90deg,
    #f4f4f4 0px,
    rgba(229, 229, 229, 0.8) 40px,
    #f4f4f4 80px
  );
  background-size: 600px;
  animation: shine-avatar 2s infinite ease-out;
}
.post .line {
  width: 24%;
  margin-left: 1%;
  float: left;
  height: 30px;
  margin-top: 4px;
  margin-bottom: 4px;
  border-radius: 7px;
  background-image: linear-gradient(
    90deg,
    #f4f4f4 0px,
    rgb(248 249 250) 40px,
    #f4f4f4 80px
  );
  background-size: 600px;
  animation: shine-lines 2s infinite ease-out;
}
.post .avatar + .line {
  margin-top: 11px;
  width: 100%;
}
.post .line ~ .line {
  background-color: #ddd;
}

.post .hotel_title_line {
  width: 100%;
  margin-left: 1%;
  float: left;
  height: 30px;
  margin-top: 4px;
  margin-bottom: 4px;
  border-radius: 7px;
  background-image: linear-gradient(
    90deg,
    #f4f4f4 0px,
    rgb(248 249 250) 40px,
    #f4f4f4 80px
  );
  background-size: 600px;
  animation: shine-lines 2s infinite ease-out;
}
@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%,
  100% {
    background-position: 140px;
  }
}
@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%,
  100% {
    background-position: 208px;
  }
}

.p-4 {
  padding: 1rem !important;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px !important;
  margin-left: 0px !important;

}
</style>


